// extracted by mini-css-extract-plugin
module.exports = {"gridStyle":"uploadSTL_gridStyle__1LhBV","rowStyle1":"uploadSTL_rowStyle1__24hQt","rowStyle2":"uploadSTL_rowStyle2__2iro1"};